import * as R from "ramda";
import React, { Component } from "react";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import { mapToObjectDDL } from "../../../../common/mapper";
import {
  ACTIVITY_TYPE,
  GenericSequenceType,
  HttpStatus,
} from "../../../../common/Constants";
import { getSupplierExpOptions } from "../util";
import M from "moment/moment";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import InventorySearchDataSPBM from "./receivingGiftSearchSPBM";
import {
  contructQueryParam,
  fetchDataAsync,
} from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";

class ReceivingInputGift extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spbmModalVisible: false,
      dataSupplier: [],
      dataSupplierExpedition: [],
      tempSPBH: null,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const { onTriggerLoading, setError, selectedCabang, activityType } =
      this.props;
    const promises = [
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getSupplierMainDealerBySourceCode,
        menuName: "Receiving Unit - DGI",
        setError: setError,
        args: contructQueryParam({
          kodeCabang: selectedCabang?.value,
        }),
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierExpedition,
        menuName: "Receiving Unit - DGI",
        setError: setError,
        args: contructQueryParam({
          kodeCabang: selectedCabang?.value,
        }),
      }),
    ];

    if (activityType === ACTIVITY_TYPE.CREATE) {
      promises.push(
        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_MASTER_DATA").generateSeqWithoutSave,
          menuName: "Receiving Gift",
          setError: setError,
          args: {
            seqType: GenericSequenceType.RECEIVING_GIFT,
            nosDealerCode: selectedCabang.value,
            transactionType: GenericSequenceType.RECEIVING_GIFT,
          },
        })
      );
    }

    onTriggerLoading();
    const res = await Promise.all(promises);
    onTriggerLoading();

    if (res[0].ok && res[0].data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataSupplier: res[0].data.data,
      });
    }

    if (res[1].ok && res[1].data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataSupplierExpedition: res[1].data.data,
      });
    }

    if (res[2] && res[2].ok && res[2].data) {
      this.setState({
        tempSPBH: res[2].data,
      });
    }
  };

  handleSelecSpbmModalVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      spbmModalVisible: !prevState.spbmModalVisible,
    }));
  };

  handleSubmitSelectSPBM = (data) => {
    if (!R.isNil(data)) {
      const { setValue } = this.props;
      setValue("spbmNo", data.spbmNo);
      setValue("spbmDate", data.spbmDate);
      setValue("slNo", data.slNo);
      setValue("slDate", data.slDate);
    }

    this.handleSelecSpbmModalVisibility();
  };

  getSupplierDDL = (data) => {
    if (data?.length > 0) {
      return data.map((item) =>
        mapToObjectDDL(item.supplierName, item.supplierCode)
      );
    }
    return [];
  };

  render() {
    const { controls, setValue, activityType, activityRead, errors } =
      this.props;
    
    const isCreate = activityType === ACTIVITY_TYPE.CREATE;
    const isUpdate = activityType === ACTIVITY_TYPE.UPDATE;
    
    const { spbmModalVisible, dataSupplierExpedition, dataSupplier, tempSPBH } =
      this.state;
    return (
      <>
        <div className="grid grid-3x grid-mobile-none gap-15px">
          <div id="grid-1">
            <SimpleInput
              id={`input_text_spbhNo`}
              name={"spbhNo"}
              readOnly
              label="No. SPBH"
              value={controls.spbhNo.value || tempSPBH}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <FlexView vAlignContent={"center"}>
              <SimpleInput
                id="input_text_nospbm"
                name="spbmNo"
                label="No. SPBM"
                readOnly
                containerclassname="width width-full"
                value={controls?.spbmNo?.value}
                onChange={({ target }) => setValue(target.name, target.value)}
              />
              {(isCreate || !activityRead) && (
                <SimpleButton
                  secondary
                  text={"..."}
                  className="margin-top-5px"
                  styles={{
                    width: "unset",
                    marginLeft: "2px",
                    border: "1px solid #ccc",
                    backgroundColor:
                      isCreate || !activityRead ? "#fff" : "#E6E6E6",
                  }}
                  onClick={this.handleSelecSpbmModalVisibility}
                />
              )}
            </FlexView>
            <SimpleInput
              id="input_text_nosl"
              name="slNo"
              label="No. SL"
              readOnly
              value={controls?.slNo?.value}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
          </div>
          <div id="grid-2">
            <SimpleDate
              id={`select_date_spbh_date`}
              name="spbhDate"
              label="Tgl. SPBH"
              date={controls?.spbhDate?.value}
              disabled={activityRead || isCreate}
              onChange={(value) =>
                setValue("spbhDate", M(value).format("DD-MM-YYYY"))
              }
            />
            <SimpleDate
              id="select_date_tglspbm"
              name="spbmDate"
              label="Tgl. SPBM"
              disabled
              date={controls?.spbmDate?.value}
              onChange={(value) =>
                setValue("spbmDate", M(value).format("DD-MM-YYYY"))
              }
            />
            <SimpleDate
              id="select_date_tglsl"
              name="slDate"
              label="Tgl. SL"
              disabled
              date={controls?.slDate?.value}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
          </div>
          <div id="grid-3">
            <SimpleDDL
              id="select_options_nama_supp"
              name="idSupplier"
              mandatory
              label="Nama Supp."
              box={"search"}
              isClearable={true}
              errorMessage={errors.idSupplier}
              readOnly={isUpdate}
              options={this.getSupplierDDL(dataSupplier)}
              value={controls.idSupplier?.value}
              onChange={(value, { name }) => setValue(name, value)}
            />
            <SimpleInput
              id="input_text_no_pol_truk"
              name="noPolKendaraan"
              label="No. Pol Truk"
              value={controls.noPolKendaraan?.value}
              readOnly={isUpdate && activityRead}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <SimpleDDL
              id="select_options_ekpedisi"
              name="idSupplierExpedisi"
              box={"search"}
              label="Ekspedisi"
              isClearable={true}
              readOnly={isUpdate && activityRead}
              options={getSupplierExpOptions(dataSupplierExpedition)}
              value={controls.idSupplierExpedisi.value}
              onChange={(value, { name }) => setValue(name, value)}
            />
          </div>
        </div>
        <div
          style={{
            display: "grid",
            gap: "15px",
            gridTemplateColumns: "1fr 1fr",
          }}
        >
          <SimpleTextArea
            typeInputCase="normal"
            name="note"
            label="Catatan"
            readOnly={isUpdate && activityRead}
            value={controls.note.value}
            onChange={({ target }) => setValue(target.name, target.value)}
          />
          <p style={{ justifySelf: "end" }}>
            {controls.idSupplierExpedisi?.value?.name}
          </p>
        </div>

        {spbmModalVisible && (
          <InventorySearchDataSPBM
            {...this.props}
            onSubmit={this.handleSubmitSelectSPBM}
            visible={spbmModalVisible}
            onClickClose={this.handleSelecSpbmModalVisibility}
          />
        )}
      </>
    );
  }
}

export default ReceivingInputGift;
